import React, { useState } from 'react';

const DeleteAccount = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [message, setMessage] = useState('');
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_HOST}/v1/auth/signin`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            const data = await response.json();

            setMessage(data?.message || 'Gagal login');

            if (data?.code === 400) {
                setIsAuthenticated(false);
                return;
            }

            sessionStorage.setItem('user', JSON.stringify(data.data));
            setIsAuthenticated(true);
        } catch (error) {
            setMessage(
                error instanceof Error ? error.message : 'Terjadi kesalahan saat login'
            );
        }
    };

    const handleDeleteAccount = () => {
        setMessage('Terima kasih permintaan anda sedang diproses');
    };

    const renderMessage = () => {
        if (!message) return null;

        const lowerMessage = message.toLowerCase();
        const bgColor = lowerMessage.includes('error') || lowerMessage.includes('gagal')
            ? 'bg-red-100 text-red-700 my-4'
            : lowerMessage.includes('sukses') || lowerMessage.includes('berhasil')
                ? 'bg-green-100 text-green-700 my-4'
                : 'bg-yellow-100 text-yellow-700 my-4';

        return (
            <div className={`p-3 rounded mb-4 text-sm font-medium ${bgColor}`}>
                {message}
            </div>
        );
    };

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded shadow-md mt-8">
            {!isAuthenticated ? (
                <>
                    <h2 className="text-2xl font-semibold mb-4 text-center">Login untuk Hapus Akun Anda</h2>
                    <form onSubmit={handleLogin} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full p-2 border rounded"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium">Password</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className="w-full p-2 border rounded"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-gradient-to-r from-blue-500 to-indigo-700 text-white py-2 rounded hover:from-blue-600 hover:to-indigo-800 transition-all duration-200 hover:shadow-xl"
                        >
                            Login
                        </button>
                    </form>
                    {renderMessage()}
                </>
            ) : (
                <>
                    <h2 className="text-2xl font-semibold mb-4 text-center">Konfirmasi Hapus Akun</h2>
                    <p className="mb-4 text-gray-600">
                        Apakah Anda yakin ingin menghapus akun Anda? Tindakan ini tidak dapat dibatalkan.
                    </p>
                    <button
                        onClick={handleDeleteAccount}
                        className="w-full bg-gradient-to-r from-red-500 to-indigo-700 text-white py-2 rounded hover:from-red-600 hover:to-indigo-800 transition-all duration-200 hover:shadow-xl"
                    >
                        Hapus Akun
                    </button>
                    {renderMessage()}
                </>
            )}
        </div>
    );
};

export default DeleteAccount;
